import { PathEndsWithRoute } from "features/common/routing/ends-with-routes";

import GlobalSignUpModalJourney from "./GlobalSignUpModalJourney";
import { openForPathsEndingWith } from "./utils";

type Props = {
  onlyAllowModalToOpenForPathsStartingWith?: string[];
  predefinedAccountType?: string;
  frontdoorModal?: boolean;
};

export default function GlobalSignUpModalJourneyRouter({
  onlyAllowModalToOpenForPathsStartingWith,
  predefinedAccountType,
  frontdoorModal
}: Props) {
  return (
    <PathEndsWithRoute
      pathsEndingWith={openForPathsEndingWith}
      onlyRenderForPathsStartingWith={onlyAllowModalToOpenForPathsStartingWith}
    >
      <GlobalSignUpModalJourney
        accountType={predefinedAccountType}
        frontdoorModal={frontdoorModal}
      />
    </PathEndsWithRoute>
  );
}
